import { VIBRATIONAL_ANALYTICS_ACTIONS } from "./action_types";

export const getPerformanceData = (payload) => ({
  type: VIBRATIONAL_ANALYTICS_ACTIONS.GET_PERFORMANCE_DATA,
  payload: payload,
});
